import { inject, Service } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, filter, Observable, switchMap, take } from 'rxjs';
import { LocationCompositeDataProvider } from '@lib.core/location/location-composite/data-provider/location-composite.data-provider';
import { LocationComposite } from '@lib.core/entities/location/location-composite.entity';
import { LocationCompositeResource } from '@lib.resources/location/location-composite.resource';
import { LocationCompositeStore } from '@lib.resources/location/location-composite.store';

@Service()
export class LocationCompositeAdapter implements LocationCompositeDataProvider {

  private readonly locationCompositeResource: LocationCompositeResource = inject(LocationCompositeStore);

  private readonly clientId$$ = new BehaviorSubject<string | null>(null);
  private readonly clientId$: Observable<string> = this.clientId$$.asObservable().pipe(filter((vc: string | null) => vc !== null));
  private readonly clientId = toSignal<string>(this.clientId$);

  setClientId(clientId: string): this {
    this.clientId$$.next(clientId);
    return this;
  }

  getLocationComposite(locationId: string): Observable<LocationComposite> {
    return this.clientId$.pipe(
      take(1),
      switchMap(() => this.locationCompositeResource.getLocationComposite(locationId, this.clientId()!))
    );
  }
}
